export default __webpack_public_path__ + "static/media/basic_mail.ac7835c6.svg";